import FavoriteAnswerConverter from 'scripts/application/dto_converters/favorite_answer_converter';
import fetchSnippetsByIds from './fetch_snippets_by_ids';

export default class RequestFavoriteAnswersFromBackend {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.gateways.favoriteAnswers
      .requestAll()
      .then(dtos => {
        if (!dtos || !dtos.length) {
          this.context.stores.favoriteAnswerRecords.set([]);
          return;
        }

        const records = dtos.map(dto => FavoriteAnswerConverter.fromDto(dto));
        this.context.stores.favoriteAnswerRecords.set(records);

        const ids = records.map(record => record.answerId);
        fetchSnippetsByIds(this.context, ids)
          .then(snippets => {
            this.context.stores.favoriteAnswers.set(snippets);
          })
          .catch(() => {});
      })
      .catch(() => {
        this.context.stores.favoriteAnswerRecords.set([]);
      });
  }
}
